import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-securitypolicy',
  templateUrl: './securitypolicy.component.html',
  styleUrls: ['./securitypolicy.component.less']
})
export class SecuritypolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
